const team = [
  {
    name: 'Scott Doolittle',
    role: 'Owner & Master Technician',
    description:
      'With nearly two decades leading Doolittle Air, Scott built this company from the ground up on a foundation of honesty, hard work, and genuine care for every customer. His expertise and leadership set the standard for everything we do.',
    image:
      'https://static.readdy.ai/image/2626c5dd14f7e79bab7b94489c13c72e/d37b67f95bf99bcabc0e769a5c8553a1.png',
    badge: 'Owner',
    badgeColor: 'bg-orange-500',
  },
  {
    name: 'Chris Doolittle',
    role: 'Lead HVAC Technician',
    description:
      'Ryan brings energy, precision, and a passion for problem-solving to every job. Trained alongside his dad and brother, he\'s become one of the most trusted technicians in the Sarasota area — always going the extra mile for customers.',
    image:
      'https://static.readdy.ai/image/2626c5dd14f7e79bab7b94489c13c72e/c5a7e14fd92be5e2ef62e34868d5644a.png',
    badge: 'Lead Tech',
    badgeColor: 'bg-slate-700',
  },
  {
    name: 'Ryan Doolittle',
    role: 'Lead HVAC Technician',
    description:
      'Chris combines technical skill with a calm, customer-first attitude that puts homeowners at ease. Whether it\'s a routine tune-up or a complex installation, Chris delivers quality work with a smile every single time.',
    image:
      'https://static.readdy.ai/image/2626c5dd14f7e79bab7b94489c13c72e/cbc144d03d60439bf57965f97898d87c.png',
    badge: 'Lead Tech',
    badgeColor: 'bg-slate-700',
  },
];

export default function MeetTheTeam() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-3">
            THE PEOPLE BEHIND THE WORK
          </p>
          <h2 className="text-5xl font-bold text-slate-900 mb-5 font-serif">
            Meet the Doolittle Family
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            We&apos;re not just a company — we&apos;re a family. When you call Doolittle Air, you get real people who care about your
            home as much as their own.
          </p>
        </div>

        {/* Team Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {team.map((member) => (
            <div
              key={member.name}
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              {/* Image */}
              <div className="relative w-full h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span
                  className={`absolute top-4 left-4 ${member.badgeColor} text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full`}
                >
                  {member.badge}
                </span>
              </div>

              {/* Info */}
              <div className="p-7">
                <h3 className="text-2xl font-bold text-slate-900 mb-1">{member.name}</h3>
                <p className="text-orange-500 font-semibold text-sm uppercase tracking-wide mb-4">
                  {member.role}
                </p>
                <p className="text-gray-500 text-sm leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 text-base mb-6">
            Ready to work with a team that treats you like family?
          </p>
          <a
            href="tel:9412233052"
            className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg px-10 py-4 rounded-full shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call Us — (941) 223-3052
          </a>
        </div>
      </div>
    </section>
  );
}
